import { css } from 'emotion';

export const errorContainer = css`
  display: flex;
  padding: 100px;
`;
